var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15H16.5V13.5C16.5 13.0324 16.3542 12.5764 16.0831 12.1955C15.812 11.8145 15.4289 11.5275 14.9871 11.3743C14.5453 11.2211 14.0667 11.2094 13.6179 11.3408C13.1692 11.4721 12.7725 11.74 12.483 12.1072M12.75 15H5.25M5.25 15V13.5C5.25 13.008 5.3445 12.5377 5.517 12.1072C5.79552 11.4112 6.27618 10.8146 6.897 10.3943C7.51782 9.97409 8.25031 9.74947 9 9.74947C9.74969 9.74947 10.4822 9.97409 11.103 10.3943C11.7238 10.8146 12.2045 11.4112 12.483 12.1072C12.6555 12.5377 12.75 13.008 12.75 13.5V15M5.25 15H1.5V13.5C1.50003 13.0324 1.64575 12.5764 1.9169 12.1955C2.18804 11.8145 2.57114 11.5275 3.01294 11.3743C3.45474 11.2211 3.93328 11.2094 4.38205 11.3408C4.83082 11.4721 5.22752 11.74 5.517 12.1072M11.25 5.25C11.25 5.84674 11.0129 6.41903 10.591 6.84099C10.169 7.26295 9.59674 7.5 9 7.5C8.40326 7.5 7.83097 7.26295 7.40901 6.84099C6.98705 6.41903 6.75 5.84674 6.75 5.25C6.75 4.65326 6.98705 4.08097 7.40901 3.65901C7.83097 3.23705 8.40326 3 9 3C9.59674 3 10.169 3.23705 10.591 3.65901C11.0129 4.08097 11.25 4.65326 11.25 5.25Z",
    stroke: "#6A7282",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupManagement);
export default __webpack_public_path__ + "static/media/GroupManagement.6d2cedc1cc0459d3b63aa00f6661a94a.svg";
export { ForwardRef as ReactComponent };